import React from 'react';

const Vue_BuiltIn_Components = () => {
  return (
    <div>
      <h1>Vue_BuiltIn_Components Component</h1>
      <p>This is the Vue_BuiltIn_Components tutorial page.</p>
    </div>
  );
}

export default Vue_BuiltIn_Components;
